import { PartnerOrganization } from './API';
import getPartnerConfig from './metadata/getPartnerConfig';
import SERVICE_REGION_LOOKUP from './metadata/SERVICE_REGION_LOOKUP';

export default function findActiveServiceRegionOrNull(
  postalCode: string | null | undefined,
  partnerOrganization: PartnerOrganization | null | undefined,
): string | null {
  if (postalCode == null) {
    return null;
  }
  const { supportedServiceRegions } = getPartnerConfig(partnerOrganization);

  const newServiceRegion = Object.keys(SERVICE_REGION_LOOKUP).find(
    (regionName) =>
      SERVICE_REGION_LOOKUP[regionName].isActive &&
      SERVICE_REGION_LOOKUP[regionName].postalCodes.has(postalCode.slice(0, 5)),
  );

  // If service region is not found or not supported for the partner return null
  if (newServiceRegion == null || !supportedServiceRegions.includes(newServiceRegion)) return null;

  return newServiceRegion;
}

export function findServiceRegionOrNull(postalCode: string | null | undefined): string | null {
  if (postalCode == null) return null;
  const serviceRegion = Object.keys(SERVICE_REGION_LOOKUP).find((regionName) =>
    SERVICE_REGION_LOOKUP[regionName].postalCodes.has(postalCode.slice(0, 5)),
  );
  return serviceRegion ?? null;
}
